export class MitigatingAction {
  id: number;
  riskId: number;
  title: string;
  controlOwnerName: string;
  description: string;
  controlEffectiveness: number;
  effectiveness: number;
  probabilityReduction: number;
  costBased: boolean;
  costReduction: number;
  controlOwner: number;
  controlStatus: number;
  controlWeighting: number;
  keyStatus: boolean;
  prevention: boolean;
  reviewAndUpdateDate: Date;

  automatic: boolean;
  controlType: number;
  frequency: number;
}

export enum Frequency {
  Daily = 1,
  Weekly,
  Monthly,
  Quarterly,
  SixMonths,
  Yearly,
  Fortnightly,
  Bimonthly,
  WhenRequired
}
